import type { SourceKind } from '../../types';

interface Props {
  kind: SourceKind | string;
  size?: number;
}

export function SourceIcon({ kind, size = 16 }: Props) {
  const s = size;

  const icons: Record<string, React.ReactNode> = {
    slack: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <rect x="2" y="8.5" width="4" height="3" rx="1.5" fill="#E01E5A" />
        <rect x="8.5" y="14" width="3" height="4" rx="1.5" fill="#2EB67D" />
        <rect x="14" y="8.5" width="4" height="3" rx="1.5" fill="#ECB22E" />
        <rect x="8.5" y="2" width="3" height="4" rx="1.5" fill="#36C5F0" />
      </svg>
    ),
    zoom: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <rect x="2" y="5" width="11" height="10" rx="2" fill="#0B5CFF" />
        <path d="M14 8.5l4-2.2v7.4l-4-2.2v-3z" fill="#0B5CFF" />
      </svg>
    ),
    fathom: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <rect x="2" y="5" width="11" height="10" rx="2" fill="#6B46C1" />
        <path d="M14 8.5l4-2.2v7.4l-4-2.2v-3z" fill="#6B46C1" />
      </svg>
    ),
    linear: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <circle cx="10" cy="10" r="8" fill="#5E6AD2" />
        <path d="M5 12.5l5-7.5M5 15l8.5-12.5M7 17l11-15" stroke="white" strokeWidth="0.9" opacity="0.85" />
      </svg>
    ),
    kb: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <path d="M4 3h9a3 3 0 013 3v11l-3-1.5L10 17l-3-1.5L4 17V3z" fill="#0D9488" />
        <path d="M6.5 7h7M6.5 10h5" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    ),
    note: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <rect x="3" y="3" width="14" height="14" rx="3" fill="#1A1F36" />
        <path d="M6.5 7.5h7M6.5 10.5h7M6.5 13.5h4" stroke="white" strokeWidth="1.2" strokeLinecap="round" />
      </svg>
    ),
    gmail: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <rect x="2" y="4" width="16" height="12" rx="2" fill="#EA4335" />
        <path d="M2 4l8 7 8-7" stroke="white" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    ),
    gdrive: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <path d="M7 14L2 6l4-3 5 8z" fill="#4285F4" />
        <path d="M13 14L8 6l4-3 5 8z" fill="#FBBC04" />
        <path d="M2 14h16" stroke="#34A853" strokeWidth="2.5" strokeLinecap="round" />
      </svg>
    ),
    ai: (
      <svg width={s} height={s} viewBox="0 0 20 20" fill="none">
        <defs>
          <linearGradient id="aiG" x1="0" y1="0" x2="20" y2="20">
            <stop offset="0" stopColor="#2D00F7" />
            <stop offset="1" stopColor="#8900F2" />
          </linearGradient>
        </defs>
        <path d="M10 2l1.6 4.8L16 8l-4.4 1.6L10 14l-1.6-4.4L4 8l4.4-1.2L10 2z" fill="url(#aiG)" />
        <circle cx="15.5" cy="15" r="1.5" fill="url(#aiG)" />
      </svg>
    ),
  };

  return <>{icons[kind] ?? icons['note']}</>;
}

export const SOURCE_META: Record<string, { label: string; color: string; bg: string }> = {
  slack:  { label: 'Slack',          color: '#4A154B', bg: '#F4DECB' },
  zoom:   { label: 'Zoom',           color: '#0B5CFF', bg: '#DBE7FF' },
  fathom: { label: 'Fathom',         color: '#6B46C1', bg: '#EDE9FE' },
  linear: { label: 'Linear',         color: '#5E6AD2', bg: '#E4E6F8' },
  kb:     { label: 'Knowledge Base', color: '#0D9488', bg: '#CFEDE9' },
  note:   { label: 'Note',           color: '#1A1F36', bg: '#EBEDF2' },
  gmail:  { label: 'Gmail',          color: '#EA4335', bg: '#FDE8E8' },
  gdrive: { label: 'Google Drive',   color: '#4285F4', bg: '#E8F0FE' },
  ai:     { label: 'AI synthesis',   color: '#2D00F7', bg: '#EDE9FE' },
};
